<template>
    <a-popup :visible="visible" @cancel="onCancel">
        <div class="tw-mx-auto tw-w-[95%] md:tw-max-w-[600px] tw-overflow-hidden tw-h-fit tw-bg-white tw-border tw-border-solid tw-border-gray-300 tw-shadow-md tw-my-10 tw-rounded">
            <div class="tw-p-4 tw-text-lg tw-border-b tw-border-solid tw-font-medium tw-text-gray-600 tw-bg-gray-50">
                {{ $t('portal.tickets.new') }}
            </div>

            <div class="tw-p-5 tw-bg-white">
                <FormField v-model="form.subject" :label="$t('portal.tickets.subject')" type="text" :error="err('subject')" />
                <div class="tw-mt-2"></div>
                <FormField v-model="form.message" :label="$t('portal.tickets.message')" type="textarea" :error="err('message')" />
            </div>

            <div class="tw-p-4 tw-border-t tw-justify-end tw-flex tw-items-center tw-gap-2 tw-bg-gray-50">
                <a-button :disabled="loading" @click="onCancel" intent="simple" class="tw-min-w-[120px]">{{ $t('buttons.cancel') }}</a-button>
                <a-button :disabled="loading" :loading="loading" @click="onSubmit" class="tw-min-w-[120px]">{{ $t('portal.tickets.submit') }}</a-button>
            </div>
        </div>
    </a-popup>
</template>

<script setup>
import { ref, watch, defineProps, defineEmits } from 'vue';
import { useI18n } from 'vue-i18n';
import FormField from '@/components/form/FormField';
import { createTicket } from '@/api/portal';
import useAlert from '@/composables/useAlert';
import { useValidation } from '@/composables/useValidation';

const props = defineProps({ visible: { type: Boolean, default: false } });
const emit = defineEmits(['cancel', 'saved']);
const i18n = useI18n();

const loading = ref(false);
const errors = ref({});
const form = ref({ subject: '', message: '' });
const err = useValidation(errors);

watch(() => props.visible, (v) => {
    if (v) { form.value = { subject: '', message: '' }; errors.value = {}; }
});

const onCancel = () => { if (!loading.value) emit('cancel'); };

const onSubmit = async () => {
    loading.value = true;
    errors.value = {};
    try {
        const { data } = await createTicket(form.value);
        if (data.code === 'SUCCESS') {
            useAlert(i18n.t('portal.tickets.created'));
            emit('saved', data.ticket);
        }
    } catch (e) {
        if (e.response?.status === 422) {
            for (const k in e.response.data.errors) errors.value[k] = e.response.data.errors[k][0];
        }
    } finally {
        loading.value = false;
    }
};
</script>
